import moment from 'moment';
import 'moment/locale/pl';

export const formatDateToLocale = ({ date }) => {
	moment.locale('pl');

	return moment(date).format('DD MMMM YYYY');
};
